import { ICommandBarStyles, IPivotStyles, mergeStyles } from "@fluentui/react";

export const portalCommandBarRailPadding = "0 14px 0 0";

export const portalCommandBarStyles: Partial<ICommandBarStyles> = {
    root: {
        padding: portalCommandBarRailPadding,
    },
};

export const portalPivotStyles: Partial<IPivotStyles> = {
    root: {
        marginTop: 4,
        marginBottom: 8,
        padding: portalCommandBarRailPadding,
    },
};

export const portalPanelCommandBarStyles: Partial<ICommandBarStyles> = {
    root: {
        borderBottom: '1px solid rgb(237, 235, 233);',
        padding: "3px 10px 3px 0",
    },
};

export const portalCommandBarSearchContainerStyles = {
    alignItems: "center",
    display: "flex",
    height: "100%",
};

export const portalCommandBarSearchContainerStyle = mergeStyles(portalCommandBarSearchContainerStyles);
